import API from './api';
import { QueryKey } from '@tanstack/react-query';

const api = new API();

export const defaultQueryFn = async ({
    queryKey: [url, params],
}: {
    queryKey: QueryKey;
}) => {
    const { data } = await api._get(`/web/${url}`, { params });
    return data;
};

export const postQueryFn = async ({
    queryKey: [url, body],
}: {
    queryKey: QueryKey;
}) => {
    const { data } = await api._post(`/web/${url}`, body);
    return data;
};
